"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    // 是否是 ios app web
    isIos: function () {
        return false;
    },
    // 是否是 android app web
    isAndroid: function () {
        return false;
    },
    // 是否是 app web
    isInApp: function () {
        return false;
    },
    // 获取客户端 xtreamId
    xStreamId: function () {
        return 'xtreamId';
    },
    // 跳转到客户端页面， 传参采用 deeplink 的自定义 uri
    navigate: function () {
        //
    },
    scanQRCode: function () {
        //
    },
    saveImageUrl: function () {
        //
    },
    saveImageBase64: function () {
        //
    },
    shareWxMiniprogram: function () {
        //
    },
    navigateToWxMiniprogram: function () {
        //
    },
    routerReplaceAll: function () {
        //
    }
};
//# sourceMappingURL=h5plusCarrier.js.map